function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
/****************************************************************
 *
 * An extension of the Game Engine for special games like
 * Poker or Blackjack where you want to start a game with
 * 2 players, but have open slots on the table that other
 * players can join at a later time. Meanwhile, players can
 * stop playing without ending the game
 *
 *
 ***************************************************************/

var Transaction = require('../../lib/saito/transaction')["default"];
var GameTemplate = require('./gametemplate');
var SaitoOverlay = require('./../saito/ui/saito-overlay/saito-overlay');
var GameTableTemplate = /*#__PURE__*/function (_GameTemplate) {
  function GameTableTemplate(app) {
    var _this;
    _classCallCheck(this, GameTableTemplate);
    _this = _callSuper(this, GameTableTemplate, [app]);
    _this.can_bet = 1;
    _this.crypto_msg = 'settles round-by-round';
    _this.opengame = true;
    //
    // We will use this as a flag for Arcade to distinguish between parent and child class
    // players still need to select 'open-game' through the Arcade game wizard to fully realize
    // differential behavior
    //

    _this.toJoin = [];
    _this.toLeave = [];
    _this.joining = {};
    _this.leaving = {};
    _this.statistical_unit = 'hand';
    _this.resetCommand = 'newround';
    _this.exitOverlay = new SaitoOverlay(app, _this, false);
    return _this;
  }
  _inherits(GameTableTemplate, _GameTemplate);
  return _createClass(GameTableTemplate, [{
    key: "initializeGame",
    value: function initializeGame() {
      _superPropGet(GameTableTemplate, "initializeGame", this, 3)([]);
    }

    //
    // Canonical hash of the consensus-critical game state at a hand boundary.
    // Used by the mid-game JOIN protocol: every player signs the commitment of
    // their own newround snapshot so a joiner can verify that the state they
    // received is the state everyone agreed on. Consensus fields only -- never
    // include per-client data (player, keys, step.players, player_names, queues).
    //
  }, {
    key: "returnStateCommitment",
    value: function returnStateCommitment(game_obj) {
      var _game_obj$state, _game_obj$state2, _game_obj$state3;
      var fields = {
        id: game_obj.id,
        players: game_obj.players,
        round: (game_obj === null || game_obj === void 0 || (_game_obj$state = game_obj.state) === null || _game_obj$state === void 0 ? void 0 : _game_obj$state.round) || 0,
        player_credit: (game_obj === null || game_obj === void 0 || (_game_obj$state2 = game_obj.state) === null || _game_obj$state2 === void 0 ? void 0 : _game_obj$state2.player_credit) || [],
        debt: (game_obj === null || game_obj === void 0 || (_game_obj$state3 = game_obj.state) === null || _game_obj$state3 === void 0 ? void 0 : _game_obj$state3.debt) || []
      };
      Object.assign(fields, this.returnExtraCommitmentFields(game_obj));
      return this.app.crypto.hash(JSON.stringify(fields));
    }

    //
    // modules may override to commit additional consensus fields
    //
  }, {
    key: "returnExtraCommitmentFields",
    value: function returnExtraCommitmentFields(game_obj) {
      return {};
    }
  }, {
    key: "pruneStateCommitments",
    value: function pruneStateCommitments() {
      var keep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      if (!this.game.state_commitments) {
        return;
      }
      var rounds = Object.keys(this.game.state_commitments).map(Number).sort(function (a, b) {
        return a - b;
      });
      while (rounds.length > keep) {
        delete this.game.state_commitments[rounds.shift()];
      }
    }

    //
    // Build the hand-boundary snapshot used to answer join requests: the game
    // state stripped of secret card data and per-client bookkeeping. Sets
    // this.cacheGame (in memory only -- a reload without a snapshot simply
    // defers signing to the next newround) and returns the serialized string so
    // callers can reuse it for a SHARE without re-serializing.
    //
  }, {
    key: "buildBoundarySnapshot",
    value: function buildBoundarySnapshot() {
      var deck = this.game.deck;
      var pool = this.game.pool;
      var commitments = this.game.state_commitments;
      this.game.deck = [];
      this.game.pool = [];
      delete this.game.state_commitments;
      var snapshot = JSON.stringify(this.game);
      this.game.deck = deck;
      this.game.pool = pool;
      if (commitments !== undefined) {
        this.game.state_commitments = commitments;
      }
      this.cacheGame = JSON.parse(snapshot);
      return snapshot;
    }

    // the message every player signs to authorize a join
  }, {
    key: "returnJoinSigMessage",
    value: function returnJoinSigMessage(pkey, round, commitment) {
      return "ADDPLAYER ".concat(pkey, " ").concat(round, " ").concat(commitment);
    }

    // has every current player signed off on this join?
  }, {
    key: "hasAllPlayerSigs",
    value: function hasAllPlayerSigs(pkey) {
      var rec = this.joining[pkey];
      if (!rec) {
        return false;
      }
      var _iterator = _createForOfIteratorHelper(this.game.players),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _rec$sigs;
          var player = _step.value;
          if (!((_rec$sigs = rec.sigs) !== null && _rec$sigs !== void 0 && _rec$sigs[player])) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true;
    }

    // clear the pending-join state once we have taken (or are taking) our seat
  }, {
    key: "finalizePendingJoin",
    value: function finalizePendingJoin() {
      delete this.game.pending_join;
      if (this.pending_join_timeout) {
        clearTimeout(this.pending_join_timeout);
        this.pending_join_timeout = null;
      }
      if (this.browser_active) {
        this.syncBodyGameClasses();
      }
      this.app.connection.emit('arcade-gametable-addplayer', this.game.id);
    }

    // re-run game initialization in place (shared by the seat handoff and the
    // fewer-players reset)
  }, {
    key: "reinitializeGameRun",
    value: function reinitializeGameRun() {
      var _this2 = this;
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var go = function go() {
        _this2.initialize_game_run = 0;
        _this2.halted = 0;
        _this2.refreshPlayerboxes();
        _this2.initializeGameQueue(_this2.game.id);
      };
      if (delay) {
        setTimeout(go, delay);
      } else {
        go();
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this$game;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.game.options['open-table']) {
                console.info('GTT: Treat table game as standard (closed) game');
                this.opengame = false;
              }
              _context.n = 1;
              return _superPropGet(GameTableTemplate, "render", this, 3)([app]);
            case 1:
              //
              // the first newround usually executes while players are still in the
              // arcade lounge, and navigating into the game room wipes the in-memory
              // snapshot -- rebuild it here so join requests can be serviced. at initial
              // render the game is parked at its boundary, so the current state IS the
              // snapshot.
              //
              if ((_this$game = this.game) !== null && _this$game !== void 0 && _this$game.player && !this.cacheGame) {
                this.buildBoundarySnapshot();
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }() // Extension for table games
  }, {
    key: "receiveMetaMessage",
    value: function () {
      var _receiveMetaMessage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(tx) {
        var txmsg, data, pkey, signer, o, msg, _this$game2, i;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!tx.isTo(this.publicKey)) {
                console.warn("GTT: processing a tx that isn't addressed to us...");
              }
              txmsg = tx.returnMessage();
              if (!(txmsg.request == 'JOIN')) {
                _context2.n = 5;
                break;
              }
              data = txmsg.data;
              pkey = data.pkey; //
              // make sure the joiner receives our sig rebroadcasts and the eventual
              // boundary SHARE, regardless of FOLLOW/JOIN arrival order
              //
              this.addFollower(pkey);

              // Temporary storage here
              if (!this.joining[pkey]) {
                this.joining[pkey] = {
                  pkey: pkey,
                  sigs: {},
                  round: data.round || 0
                };

                //
                // let seated players know right away
                //
                if (this.game.player && pkey !== this.publicKey) {
                  siteMessage("".concat(this.app.keychain.returnUsername(pkey), " will join at the next round"), 3000);
                }
              }

              //
              // merge incoming signatures -- keyed by signer pubkey, and only those
              // that cryptographically verify against the signer's key
              //
              for (signer in data.sigs || {}) {
                o = data.sigs[signer];
                if (o !== null && o !== void 0 && o.sig && !this.joining[pkey].sigs[signer]) {
                  msg = this.returnJoinSigMessage(pkey, o.round, o.commitment);
                  if (this.app.crypto.verifyMessage(msg, o.sig, signer)) {
                    this.joining[pkey].sigs[signer] = o;
                    this.joining[pkey].round = Math.max(this.joining[pkey].round, o.round);
                  } else {
                    console.warn("GTT: invalid JOIN sig from ".concat(signer, " -- discarding"));
                  }
                }
              }

              //
              // I am a player: add my signature, anchored to my newround snapshot.
              // If I have no snapshot yet (e.g. reloaded mid-hand), the resetCommand
              // hook signs at the next newround instead.
              //
              if (!(this.game.player && !this.joining[pkey].sigs[this.publicKey])) {
                _context2.n = 3;
                break;
              }
              if (!this.cacheGame) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.signJoinRequest(pkey);
            case 1:
              return _context2.a(2);
            case 2:
              console.warn('GTT: no snapshot yet -- will sign join request at next newround');
            case 3:
              if (!(this.game.pending_join && pkey === this.publicKey)) {
                _context2.n = 4;
                break;
              }
              this.checkPendingJoinReady();
              if (!this.game.over) {
                _context2.n = 4;
                break;
              }
              return _context2.a(2);
            case 4:
              this.countJoinAuths(pkey);
              return _context2.a(2);
            case 5:
              if (!(txmsg.request == 'LEAVE')) {
                _context2.n = 6;
                break;
              }
              console.info('GTT: Leave request:' + txmsg.my_key);
              if (!this.toLeave.includes(txmsg.my_key)) {
                this.toLeave.push(txmsg.my_key);
                siteMessage("".concat(this.publicKey == txmsg.my_key ? 'You' : this.app.keychain.returnUsername(txmsg.my_key), " will leave the table after this hand"), 2500);
              }
              return _context2.a(2);
            case 6:
              if (!(txmsg.request == 'CANCEL')) {
                _context2.n = 7;
                break;
              }
              this.toJoin = this.toJoin.filter(function (key) {
                return key !== txmsg.my_key;
              });
              this.toLeave = this.toLeave.filter(function (key) {
                return key !== txmsg.my_key;
              });
              delete this.joining[txmsg.my_key];
              siteMessage("".concat(this.app.keychain.returnUsername(txmsg.my_key), " changed their mind"), 2500);
              return _context2.a(2);
            case 7:
              if (!(txmsg.request == 'SETTLEMENT')) {
                _context2.n = 8;
                break;
              }
              console.info("GTT: ".concat(tx.from[0].publicKey, " requested we settle at the end of the round"));
              this.settleNow = true;
              siteMessage('Will settle at the end of the round', 1500);
              return _context2.a(2);
            case 8:
              if (!(txmsg.request == 'FOLLOW')) {
                _context2.n = 9;
                break;
              }
              this.addFollower(txmsg.my_key);
              if (!tx.isFrom(this.publicKey)) {
                if (this.cacheGame) {
                  this.sendMetaMessage('SHARE', JSON.stringify(this.cacheGame));
                } else {
                  // no boundary snapshot yet -- ack now, share at the next newround
                  this.share_state_on_snapshot = true;
                  this.sendMetaMessage('SHARE', '');
                }
              }
              return _context2.a(2);
            case 9:
              if (!(txmsg.request == 'SHARE')) {
                _context2.n = 10;
                break;
              }
              for (i = 0; i < tx.to.length; i++) {
                this.addFollower(tx.to[i].publicKey);
              }
              if ((_this$game2 = this.game) !== null && _this$game2 !== void 0 && _this$game2.pending_join && txmsg.game_id == this.game.id) {
                this.adoptSharedTableState(tx);
              }
              return _context2.a(2);
            case 10:
              _superPropGet(GameTableTemplate, "receiveMetaMessage", this, 3)([tx]);
            case 11:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function receiveMetaMessage(_x2) {
        return _receiveMetaMessage.apply(this, arguments);
      }
      return receiveMetaMessage;
    }() //
    // Adopt a hand-boundary snapshot received while waiting for a seat. If the
    // snapshot already lists us as a player, the table seated us at the last
    // boundary and we take our seat directly; otherwise we hold the pre-seat
    // state (following as player 0) and record a commitment baseline so
    // incoming signatures can be verified against exactly what we hold.
    //
  }, {
    key: "adoptSharedTableState",
    value: function adoptSharedTableState(tx) {
      var _this$game3;
      var txmsg = tx.returnMessage();

      // any response proves the table is live -- stop the no-response timer
      if (this.pending_join_timeout && !this.join_ready_emitted) {
        clearTimeout(this.pending_join_timeout);
        this.pending_join_timeout = null;
      }
      if (!txmsg.data) {
        console.info('GTT [SHARE] responder has no snapshot yet -- awaiting deferred share');
        return;
      }
      console.info('GTT [SHARE] adopting shared table state', tx.from[0].publicKey);
      var buffered_future = ((_this$game3 = this.game) === null || _this$game3 === void 0 ? void 0 : _this$game3.future) || [];
      this.game = JSON.parse(txmsg.data);
      this.game.live = true;
      var my_seat = this.game.players.indexOf(this.publicKey);
      if (my_seat >= 0) {
        this.game.player = my_seat + 1;
        delete this.game.pending_join;
      } else {
        var _this$game$state;
        this.game.player = 0;
        this.game.pending_join = true;
        if (!this.game.state_commitments) {
          this.game.state_commitments = {};
        }
        this.game.state_commitments[((_this$game$state = this.game.state) === null || _this$game$state === void 0 ? void 0 : _this$game$state.round) || 0] = this.returnStateCommitment(this.game);
      }

      //
      // moves that raced ahead of this SHARE were buffered on the stub -- carry
      // them over so we don't lose the first moves of the new hand (stale ones
      // are discarded by processFutureMoves)
      //
      if (!Array.isArray(this.game.future)) {
        this.game.future = [];
      }
      var _iterator2 = _createForOfIteratorHelper(buffered_future),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var ftx = _step2.value;
          if (!this.game.future.includes(ftx)) {
            this.game.future.push(ftx);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.saveGame(this.game.id);
      if (my_seat >= 0) {
        // seated via the boundary handoff
        this.finalizePendingJoin();
        if (this.gameBrowserActive()) {
          this.reinitializeGameRun();
        } else {
          this.emitGameReadyRender();
        }
      } else {
        // signatures may already be complete -- can we enter the room yet?
        this.checkPendingJoinReady();
      }
    }
  }, {
    key: "syncPlayerJoins",
    value: function syncPlayerJoins() {
      for (var pkey in this.joining) {
        this.countJoinAuths(pkey);
      }
    }

    //
    // sign a pending join request against our own newround snapshot and
    // rebroadcast the updated request so other players / the joiner can merge
    //
  }, {
    key: "signJoinRequest",
    value: function () {
      var _signJoinRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(pkey) {
        var _this$cacheGame$state;
        var round, commitment, _t, _t2, _t3, _t4, _t5;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(!this.cacheGame || !this.joining[pkey])) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              round = ((_this$cacheGame$state = this.cacheGame.state) === null || _this$cacheGame$state === void 0 ? void 0 : _this$cacheGame$state.round) || 0;
              commitment = this.returnStateCommitment(this.cacheGame);
              _t = this.app.crypto;
              _t2 = this.returnJoinSigMessage(pkey, round, commitment);
              _context3.n = 2;
              return this.app.wallet.getPrivateKey();
            case 2:
              _t3 = _t.signMessage.call(_t, _t2, _context3.v);
              _t4 = round;
              _t5 = commitment;
              this.joining[pkey].sigs[this.publicKey] = {
                sig: _t3,
                round: _t4,
                commitment: _t5
              };
              this.joining[pkey].round = Math.max(this.joining[pkey].round, round);
              this.sendMetaMessage('JOIN', this.joining[pkey]);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function signJoinRequest(_x3) {
        return _signJoinRequest.apply(this, arguments);
      }
      return signJoinRequest;
    }() //
    // a join is authorized once every CURRENT player has a verified signature
    // on it (sigs from departed players are simply ignored)
    //
  }, {
    key: "countJoinAuths",
    value: function countJoinAuths(pkey) {
      if (!this.joining[pkey] || this.toJoin.includes(pkey)) {
        return;
      }

      //
      // the joiner does not self-authorize -- their seat arrives via the
      // boundary state handoff, not via their own toJoin list
      //
      if (!this.game.player && pkey === this.publicKey) {
        return;
      }
      if (!this.hasAllPlayerSigs(pkey)) {
        return;
      }
      if (this.currentRound() >= this.joining[pkey].round) {
        this.toJoin.push(pkey);
        siteMessage("".concat(this.publicKey == pkey ? 'You' : this.app.keychain.returnUsername(pkey), " will be dealt in next hand"), 2500);
        console.debug('GTT: JOIN SUCCESS:', JSON.parse(JSON.stringify(this.toJoin)));
      } else {
        console.warn("GTT: Don't add player because other players have already started next round!");
      }
    }

    //
    // joiner-side check: mutual consistency. we are not following the game, so
    // we cannot compare sigs against our own experience of the state -- but
    // every player who signs for the same round must commit to an IDENTICAL
    // state, and no single player can forge the others' signatures. if we do
    // hold a local baseline for a round (recorded while live-following), it
    // must match as well.
    //
  }, {
    key: "verifyPendingJoin",
    value: function verifyPendingJoin() {
      var mine = this.joining[this.publicKey];
      if (!mine) {
        return true;
      }
      var commitments = {}; // round -> commitment
      for (var signer in mine.sigs) {
        var o = mine.sigs[signer];
        if (o !== null && o !== void 0 && o.sig) {
          var _this$game$state_comm;
          if (commitments[o.round] && commitments[o.round] !== o.commitment) {
            this.abortPendingJoin('players disagree about the table state');
            return false;
          }
          commitments[o.round] = o.commitment;
          var local = (_this$game$state_comm = this.game.state_commitments) === null || _this$game$state_comm === void 0 ? void 0 : _this$game$state_comm[o.round];
          if (local && local !== o.commitment) {
            this.abortPendingJoin('table state does not match the state you were given');
            return false;
          }
        }
      }
      return true;
    }
  }, {
    key: "abortPendingJoin",
    value: function abortPendingJoin(reason) {
      console.error('GTT: aborting join -- ' + reason);
      this.sendMetaMessage('CANCEL');
      delete this.joining[this.publicKey];
      delete this.game.pending_join;
      this.game.over = 2;
      this.saveGame(this.game.id);
      if (this.browser_active) {
        this.syncBodyGameClasses();
      }
      salert("Unable to join this table: ".concat(reason, ". Returning to Arcade."));
      this.exitGame();
    }

    //
    // Voluntarily revoke a pending seat request (from the arcade lounge). Unlike
    // abortPendingJoin this is user-initiated and not an error, so it just
    // withdraws quietly and hides the abandoned stub from the arcade.
    //
  }, {
    key: "cancelPendingJoin",
    value: function cancelPendingJoin() {
      var _this$game4, _this$game5, _this$game6;
      var game_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$game4 = this.game) === null || _this$game4 === void 0 ? void 0 : _this$game4.id;
      if (game_id && ((_this$game5 = this.game) === null || _this$game5 === void 0 ? void 0 : _this$game5.id) !== game_id) {
        this.loadGame(game_id);
      }
      if (!((_this$game6 = this.game) !== null && _this$game6 !== void 0 && _this$game6.pending_join)) {
        return;
      }
      if (this.pending_join_timeout) {
        clearTimeout(this.pending_join_timeout);
        this.pending_join_timeout = null;
      }
      this.sendMetaMessage('CANCEL');
      delete this.joining[this.publicKey];
      delete this.game.pending_join;
      this.game.over = 2; // hide the abandoned stub from arcade continue-lists
      this.saveGame(this.game.id);
      siteMessage('Cancelled your seat request', 2500);
    }

    //
    // Request a seat at an in-progress open table (called from the arcade).
    // Reuses the observer stub bootstrap (player = 0, accepted = invite
    // players), FOLLOWs for the current state, and broadcasts a JOIN request
    // for the seated players to sign. Signatures collect during the current
    // hand; the seat is assigned (and the state handed off) when it ends.
    //
  }, {
    key: "requestSeatAtTable",
    value: function () {
      var _requestSeatAtTable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(game_tx) {
        var _this$game8,
          _this3 = this;
        var game_id, _this$game7;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              game_id = game_tx.signature;
              if (!this.doesGameExistLocally(game_id)) {
                _context4.n = 1;
                break;
              }
              this.loadGame(game_id);
              if (!((_this$game7 = this.game) !== null && _this$game7 !== void 0 && (_this$game7 = _this$game7.players) !== null && _this$game7 !== void 0 && _this$game7.includes(this.publicKey))) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, 'already-playing');
            case 1:
              if (!(((_this$game8 = this.game) === null || _this$game8 === void 0 ? void 0 : _this$game8.id) !== game_id)) {
                _context4.n = 2;
                break;
              }
              _context4.n = 2;
              return this.initializeObserverMode(game_tx, true);
            case 2:
              this.game.pending_join = true; // persisted -- survives navigation and reloads
              this.game.initializing = 1; // arcade lounge shows the initializing spinner
              this.join_ready_emitted = false;
              this.saveGame(this.game.id);

              //
              // FOLLOW gets us onto every player's accepted[] list and prompts a SHARE
              // of their latest hand-boundary snapshot
              //
              _context4.n = 3;
              return this.sendMetaMessage('FOLLOW');
            case 3:
              //
              // broadcast the join request -- players sign against their own snapshots
              //
              this.joining[this.publicKey] = {
                pkey: this.publicKey,
                sigs: {},
                round: 0
              };
              _context4.n = 4;
              return this.sendMetaMessage('JOIN', this.joining[this.publicKey]);
            case 4:
              //
              // nobody home? don't leave the joiner staring at a spinner forever
              //
              this.pending_join_timeout = setTimeout(function () {
                var _this3$game;
                if ((_this3$game = _this3.game) !== null && _this3$game !== void 0 && _this3$game.pending_join && !_this3.join_ready_emitted) {
                  delete _this3.game.pending_join;
                  _this3.saveGame(_this3.game.id);
                  salert('Unable to join: the players did not respond. Try again later.');
                }
              }, 20000);
              return _context4.a(2, 'requested');
          }
        }, _callee4, this);
      }));
      function requestSeatAtTable(_x4) {
        return _requestSeatAtTable.apply(this, arguments);
      }
      return requestSeatAtTable;
    }() //
    // the joiner is cleared to enter the game room once (a) the shared state
    // has been adopted and (b) every player has a verified signature over it.
    // called from the JOIN merge path and from SHARE adoption, whichever
    // completes last.
    //
  }, {
    key: "checkPendingJoinReady",
    value: function checkPendingJoinReady() {
      var _this$game9, _this$game0;
      if (!((_this$game9 = this.game) !== null && _this$game9 !== void 0 && _this$game9.pending_join) || this.join_ready_emitted) {
        return;
      }

      // verify first -- this can abort the join on a bad/conflicting commitment,
      // and is worth doing even before we have adopted the state
      if (!this.verifyPendingJoin()) {
        return;
      }

      // state adopted (the stub has no state object) and everyone has signed?
      if (!((_this$game0 = this.game) !== null && _this$game0 !== void 0 && _this$game0.state) || !this.hasAllPlayerSigs(this.publicKey)) {
        return;
      }
      this.join_ready_emitted = true;
      if (this.pending_join_timeout) {
        clearTimeout(this.pending_join_timeout);
        this.pending_join_timeout = null;
      }
      siteMessage('Seat confirmed -- you will be dealt in at the next round', 3000);

      //
      // the ready-render drives the arcade "Start Game" lounge -- only meaningful
      // while the joiner is still in the arcade. if they already clicked into the
      // game room, skip it (they get seated in place via the state handoff).
      //
      if (!this.gameBrowserActive()) {
        this.emitGameReadyRender();
      }
    }
  }, {
    key: "addPlayerLate",
    value: function addPlayerLate(address) {
      if (!this.addPlayer(address)) {
        return;
      }
      //To add a player after the game started,
      // need to assign this.game.player
      // add key
      if (this.publicKey === address) {
        this.game.player = this.game.players.length;
      }
      this.game.keys.push(address);
    }
  }, {
    key: "addPlayerToState",
    value: function addPlayerToState(address) {
      console.error('GTT: Did you define addPlayerToState in your game module?');
    }
  }, {
    key: "refreshPlayerboxes",
    value: function refreshPlayerboxes() {
      console.error('GTT: Did you define refreshPlayerboxes in your game module?');
    }
  }, {
    key: "receiveStopGameTransaction",
    value: function () {
      var _receiveStopGameTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(resigning_player, txmsg) {
        var i;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(this.game.players.length == 2)) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return _superPropGet(GameTableTemplate, "receiveStopGameTransaction", this, 3)([resigning_player, txmsg]);
            case 1:
              return _context5.a(2);
            case 2:
              if (this.publicKey === resigning_player) {
                this.game.over = 2;
                this.saveGame(this.game.id);
              }

              //Stop receiving game txs
              if (this.game.players.includes(resigning_player)) {
                _context5.n = 3;
                break;
              }
              //Player already not an active player, make sure they are also removed from accepted to stop receiving messages
              for (i = this.game.accepted.length; i >= 0; i--) {
                if (this.game.accepted[i] == resigning_player) {
                  this.game.accepted.splice(i, 1);
                }
              }
              console.warn("GTT: ".concat(resigning_player, " not in ").concat(JSON.stringify(this.game.players)));
              this.saveGame(this.game.id);
              return _context5.a(2);
            case 3:
              //Schedule to leave at end of round
              if (!this.toLeave.includes(resigning_player)) {
                this.toLeave.push(resigning_player);
              }
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function receiveStopGameTransaction(_x5, _x6) {
        return _receiveStopGameTransaction.apply(this, arguments);
      }
      return receiveStopGameTransaction;
    }() //
    // Overwrite gametemplate-web3 function because these games are more complicated
    // Todo: check that there is no remaining debt
    //
  }, {
    key: "queueGameStakeSettlement",
    value: function queueGameStakeSettlement() {
      if (_typeof(this.game.stake) == 'object') {
        console.debug('GTT [queueGameStakeSettlement]: use standard end game log for asymmetrical winner-take-all');
        _superPropGet(GameTableTemplate, "queueGameStakeSettlement", this, 3)([]);
      } else {
        this.settleDebt();
      }
    }

    //
    // Execute any settlement we still owe before withdrawing from the table, so
    // that "leave now" cannot be used to walk out on debts from a finished hand.
    //
    // Two sources:
    //  (1) SEND instructions already on the queue where we are the sender --
    //      replayed with their original unique_hash, so the opponent's pending
    //      RECEIVE can resolve and the wallet can dedupe if the queued send
    //      already fired
    //  (2) debt accrued in game.state.debt that has not been converted into
    //      queued payments yet (player exits before the settle instruction runs)
    //
    // Resolves once the wallet has processed the payments, so the caller can
    // safely navigate away afterwards.
    //
  }, {
    key: "settleDebtsOnExit",
    value: function () {
      var _settleDebtsOnExit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this$game1, _this$game$state2;
        var payments, i, mv, me, j, amount_owed, _i, _payments, payment;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(!((_this$game1 = this.game) !== null && _this$game1 !== void 0 && _this$game1.crypto) || this.game.crypto === 'CHIPS')) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              payments = []; //
              // (1) queued SENDs where we are the sender
              //
              for (i = this.game.queue.length - 1; i >= 0; i--) {
                mv = this.game.queue[i].split('\t');
                if (mv[0] === 'SEND' && mv[1] === this.publicKey) {
                  payments.push({
                    receiver: mv[2],
                    amount: mv[3],
                    unique_hash: mv[5],
                    ticker: mv[6] || this.game.crypto
                  });
                  this.game.queue.splice(i, 1);
                }
              }

              //
              // (2) accrued debt not yet queued -- same pairing logic as settleDebt()
              //
              if ((_this$game$state2 = this.game.state) !== null && _this$game$state2 !== void 0 && _this$game$state2.debt && _typeof(this.game.stake) != 'object') {
                me = this.game.players.indexOf(this.publicKey);
                if (me >= 0 && this.game.state.debt[me] > 0) {
                  for (j = 0; j < this.game.state.debt.length && this.game.state.debt[me] > 0; j++) {
                    if (this.game.state.debt[j] < 0) {
                      amount_owed = Math.min(Math.abs(this.game.state.debt[j]), this.game.state.debt[me]);
                      if (amount_owed > 0) {
                        this.game.state.debt[me] -= amount_owed;
                        this.game.state.debt[j] += amount_owed;
                        payments.push({
                          receiver: this.game.players[j],
                          amount: typeof this.convertChipsToCrypto === 'function' ? this.convertChipsToCrypto(amount_owed) : String(amount_owed),
                          unique_hash: null,
                          ticker: this.game.crypto
                        });
                      }
                    }
                  }
                }
              }
              if (!(payments.length == 0)) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              this.saveGame(this.game.id);
              _i = 0, _payments = payments;
            case 3:
              if (!(_i < _payments.length)) {
                _context6.n = 5;
                break;
              }
              payment = _payments[_i];
              _context6.n = 4;
              return this.executeExitPayment(payment);
            case 4:
              _i++;
              _context6.n = 3;
              break;
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function settleDebtsOnExit() {
        return _settleDebtsOnExit.apply(this, arguments);
      }
      return settleDebtsOnExit;
    }() //
    // To-do [note for Dave]
    // This will make sure that debts for completed hands get processed when the player is leaving immediately
    // through the menu.
    // However, there is still a flaw about the current pot-stake that the player has bet in the live round,
    // since we don't know who the ultimate winner will be.
    //
    // This might be the perfect place for the multisig spendable nfts
    // (or it may be much simpler to put the entire stake in escrow, like that)
    //
    // Or it may be simpler to just simplify exitGame and not give them the opportunity to "Leave Now"
    // and the standard pokerqueue logic will deal them out at the end of the hand for a clean exit
    //
  }, {
    key: "executeExitPayment",
    value: function () {
      var _executeExitPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref) {
        var receiver, amount, unique_hash, ticker, amount_for_unique_hash, sender_crypto_address, receiver_crypto_address, i, robj;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              receiver = _ref.receiver, amount = _ref.amount, unique_hash = _ref.unique_hash, ticker = _ref.ticker;
              amount = this.app.crypto.convertFloatToSmartPrecision(parseFloat(amount));

              //
              // accrued-debt payments have no hash yet -- derive one the same way
              // addPaymentToQueue does, so the wallet can dedupe on it
              //
              if (!unique_hash) {
                this.rollDice();
                amount_for_unique_hash = amount;
                if (ticker == 'SAITO') {
                  amount_for_unique_hash = this.app.wallet.convertSaitoToNolan(amount_for_unique_hash).toString();
                }
                unique_hash = this.app.crypto.hash(Buffer.from(this.publicKey + receiver + amount_for_unique_hash + this.game.dice + ticker, 'utf-8'));
              }
              sender_crypto_address = '';
              receiver_crypto_address = '';
              for (i = 0; i < this.game.players.length; i++) {
                if (this.game.players[i] === this.publicKey) {
                  sender_crypto_address = this.game.keys[i];
                }
                if (this.game.players[i] === receiver) {
                  receiver_crypto_address = this.game.keys[i];
                }
              }
              if (!(!sender_crypto_address || !receiver_crypto_address)) {
                _context7.n = 1;
                break;
              }
              console.warn("GTT [settleDebtsOnExit] cannot resolve addresses to pay ".concat(receiver));
              return _context7.a(2);
            case 1:
              console.info("GTT [settleDebtsOnExit] paying ".concat(amount, " ").concat(ticker, " to ").concat(receiver, " on exit"));

              //
              // informational overlay -- no mycallback, we await the payment ourselves
              //
              this.app.connection.emit('saito-crypto-send-confirm-open-request', {
                publicKey: receiver,
                address: receiver_crypto_address,
                amount: amount,
                ticker: ticker,
                hash: unique_hash,
                game_id: this.game.id,
                trusted: true
              });
              _context7.n = 2;
              return this.app.wallet.sendPayment(ticker, [sender_crypto_address], [receiver_crypto_address], [amount], unique_hash, null, receiver, "".concat(this.name, " stake"));
            case 2:
              robj = _context7.v;
              this.app.connection.emit('saito-crypto-send-confirm', robj);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function executeExitPayment(_x7) {
        return _executeExitPayment.apply(this, arguments);
      }
      return executeExitPayment;
    }()
  }, {
    key: "resetGameWithFewerPlayers",
    value: function resetGameWithFewerPlayers() {
      console.log('!!!!!!!!!!!!!!!!!!!!\n', '!!! GAME UPDATED !!!\n', '!!!!!!!!!!!!!!!!!!!!');
      console.log('My Public Key: ' + this.publicKey);
      console.log('My Position: ' + this.game.player);
      console.log('ALL PLAYERS: ' + JSON.stringify(this.game.players));
      console.log('ALL KEYS: ' + JSON.stringify(this.game.keys));
      console.log('saving with id: ' + this.game.id);
      console.log('!!!!!!!!!!!!!!!!!!!!\n', '!!!!!!!!!!!!!!!!!!!!\n', '!!!!!!!!!!!!!!!!!!!!\n');
      this.game.queue = [this.resetCommand];
      this.game.live = true;
      this.saveGame(this.game.id);
      this.reinitializeGameRun(1000);
    }
  }, {
    key: "exitConfirmationTemplate",
    value: function exitConfirmationTemplate() {
      return "<div class=\"saito-modal saito-modal-menu game-exit-menu\" id=\"saito-exit-menu\">\n            <div class=\"saito-modal-title\">Exit Game / Leave Table</div>\n            <div class=\"saito-modal-content saito-menu-select-heavy\">\n              <div class=\"saito-modal-menu-option\" id=\"stay\">\n                <i class=\"fa-solid fa-play\"></i>\n                <div class=\"option-keyword\">Continue playing</div>\n              </div>\n              <div class=\"saito-modal-menu-option\" id=\"finish\">\n                <i class=\"fa-solid fa-forward-step\"></i>\n                <div class=\"option-keyword\">Finish Hand<span>--</span><span class=\"option-explanation\">play out the hand and then leave</span></div>\n              </div>\n              <div class=\"saito-modal-menu-option\" id=\"forfeit\">\n                <i class=\"fa-solid fa-door-open\"></i>\n                <div class=\"option-keyword\">Leave now<span>--</span><span class=\"option-explanation\">abandon the current hand, settle any debts, and quit the game</span></div>\n              </div>\n            </div>\n          </div>";
    }
  }, {
    key: "exitGame",
    value: function () {
      var _exitGame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var game_self;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (this.game.over == 0 && this.game.player && this.game.options['open-table']) {
                //this.game.state.passed[loser - 1] = 1;

                this.exitOverlay.show(this.exitConfirmationTemplate());
                this.exitOverlay.blockClose();
                game_self = this;
                $('.saito-modal-menu-option').off();
                $('.saito-modal-menu-option').on('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
                  var choice;
                  return _regenerator().w(function (_context8) {
                    while (1) switch (_context8.n) {
                      case 0:
                        choice = $(this).attr('id');
                        game_self.exitOverlay.remove();
                        if (!(choice == 'stay')) {
                          _context8.n = 1;
                          break;
                        }
                        return _context8.a(2);
                      case 1:
                        if (!(choice == 'forfeit')) {
                          _context8.n = 4;
                          break;
                        }
                        _context8.n = 2;
                        return game_self.settleDebtsOnExit();
                      case 2:
                        _context8.n = 3;
                        return game_self.sendStopGameTransaction('withdraw');
                      case 3:
                        game_self.game.over = 2;
                        game_self.removePlayer(game_self.publicKey);
                        game_self.saveGame(game_self.game.id);
                        setTimeout(function () {
                          //Recursive but will call super because changed the flag
                          game_self.exitGame();
                        }, 500);
                      case 4:
                        if (choice == 'finish') {
                          game_self.sendMetaMessage('LEAVE');
                        }
                      case 5:
                        return _context8.a(2);
                    }
                  }, _callee8, this);
                })));
              } else {
                _superPropGet(GameTableTemplate, "exitGame", this, 3)([]);
              }
            case 1:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function exitGame() {
        return _exitGame.apply(this, arguments);
      }
      return exitGame;
    }()
    /**
     * Definition of core gaming logic commands
     */
  }, {
    key: "initializeQueueCommands",
    value: function initializeQueueCommands() {
      var _this4 = this;
      //Take all Game Engine Commands
      _superPropGet(GameTableTemplate, "initializeQueueCommands", this, 3)([]);
      this.commands.unshift(function (game_self, gmv) {
        if (gmv[0] === _this4.resetCommand) {
          //
          // record the consensus commitment for this snapshot round -- every
          // client (including a pending joiner) executes this at an identical
          // point in the queue, so the commitments are directly comparable
          //
          if (!_this4.game.state_commitments) {
            _this4.game.state_commitments = {};
          }
          _this4.game.state_commitments[_this4.currentRound()] = _this4.returnStateCommitment(_this4.game);
          _this4.pruneStateCommitments();
          if (_this4.game.player) {
            var snapshot = _this4.buildBoundarySnapshot();

            //
            // sign any join requests we deferred for lack of a snapshot
            //
            for (var pkey in _this4.joining) {
              var _this4$joining$pkey$s;
              if (pkey !== _this4.publicKey && !((_this4$joining$pkey$s = _this4.joining[pkey].sigs) !== null && _this4$joining$pkey$s !== void 0 && _this4$joining$pkey$s[_this4.publicKey])) {
                _this4.signJoinRequest(pkey);
              }
            }

            //
            // send any state share we deferred (reuse the serialized snapshot)
            //
            if (_this4.share_state_on_snapshot) {
              _this4.share_state_on_snapshot = false;
              _this4.sendMetaMessage('SHARE', snapshot);
            }
          } else if (_this4.game.pending_join) {
            //
            // re-check any sigs whose round we have just caught up to
            //
            _this4.verifyPendingJoin();
          }
        }
        return 1;
      });

      //Add some more ones
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'ADDPLAYER') {
          var pkey = gmv[1];
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
          console.info('GTT: Adding ' + pkey + ' to game');
          _this4.addPlayerLate(pkey); // Adds player to game
          _this4.addPlayerToState(pkey);
          _this4.updateLog('================');
          _this4.updateLog("".concat(_this4.app.keychain.returnUsername(pkey), " joins the table as Player ").concat(_this4.game.players.length));
          if (pkey === _this4.publicKey) {
            _this4.finalizePendingJoin();
          } else if (_this4.game.player === 1) {
            //
            // a joiner was seated but has not followed the game -- one seated
            // player (seat 1) shares the post-seat boundary snapshot at the next
            // newround so they can adopt their seat via state handoff
            //
            _this4.share_state_on_snapshot = true;
          }

          // Clear toJoin
          for (var j = _this4.toJoin.length - 1; j >= 0; j--) {
            if (_this4.toJoin[j] == pkey) {
              _this4.toJoin.splice(j, 1);
            }
          }
          delete _this4.joining[pkey];
        }
        return 1;
      });
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'REMOVEPLAYER') {
          var pkey = gmv[1];
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
          console.info('GTT: Removing ' + pkey + ' from game');
          var i = _this4.game.players.indexOf(pkey);
          _this4.updateLog("Player ".concat(i + 1, " (").concat(_this4.app.keychain.returnUsername(pkey), ") leaves the table."));
          _this4.removePlayer(pkey);
          if (pkey == _this4.publicKey) {
            _this4.updateStatusForPlayerOut('You cashed out of the table game');
          }
        }
        return 1;
      });
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'RESTARTGAME') {
          _this4.toLeave = [];
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
          if (game_self.game.players.length === 1) {
            _this4.game.queue.push('checkplayers');
            return 1;
          }
          _this4.halted = 1;
          _this4.resetGameWithFewerPlayers();
          return 0;
        }
        return 1;
      });
      this.commands.push(function (game_self, gmv) {
        if (gmv[0] === 'PLAYERS') {
          console.log('GTT: PLAYERS:', JSON.parse(JSON.stringify(_this4.toJoin)), JSON.parse(JSON.stringify(_this4.joining)));
          var change = _this4.toLeave.length + _this4.toJoin.length > 0;
          game_self.game.queue.splice(game_self.game.queue.length - 1, 1);
          if (change) {
            var player_to_send = 0;
            for (var i = 0; i < _this4.game.players.length; i++) {
              if (!_this4.toLeave.includes(_this4.game.players[i])) {
                player_to_send = i + 1;
                break;
              }
            }

            //Player one handles the move
            if (_this4.game.player == player_to_send) {
              var player_count = _this4.game.players.length;
              _this4.addMove('RESTARTGAME');
              var _iterator3 = _createForOfIteratorHelper(_this4.toLeave),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _pkey = _step3.value;
                  if (_this4.game.players.includes(_pkey)) {
                    _this4.addMove("REMOVEPLAYER\t".concat(_pkey));
                    player_count--;
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              for (var _i2 = 0; _i2 < _this4.toJoin.length && player_count++ < _this4.maxPlayers; _i2++) {
                var pkey = _this4.toJoin[_i2];
                _this4.addMove("ADDPLAYER\t".concat(pkey));
              }
              _this4.endTurn();
            }
            return 0;
          }
        }
        return 1;
      });
    }
  }]);
}(GameTemplate);
module.exports = GameTableTemplate;